<div class="row" [ngClass]="{ 'mt-4 mb-4': mappedData && mappedData.length > 0 }">
  <div *ngFor="let data of mappedData; last as isLast" class="col-6 col-md-4 col-lg-3 mb-2">
    <div class="card product-card">
      <div class="card-body">
        <div>
          <span class="favourite-icon-wrapper">
            <lib-favourite-product-icon [id]="data.product.id"></lib-favourite-product-icon>
          </span>
        </div>
        <div class="image-wrapper" (click)="goToDetail(data.product)">
          <img *ngIf="data.product.extra.images && data.product.extra.images[0] as image; else noimage"
            class="img-fluid" src="https://cdn1.gung.io/fit-in/250x250/filters:etag({{ image.s3ETag }})/{{
              image.s3Uri
            }}" alt="" />
          <ng-template #noimage>
            <img class="card-img-top img-fluid w-100"
              src="https://cdn1.gung.io/fit-in/300x300/images/no-image.jpg" alt="NO IMAGE"
              class="img-fluid mx-auto d-block" />
          </ng-template>
        </div>
        <div class="pb-1">
          <div class="text-center" *ngIf="data.product.productType === 'concept'">
            <span *ngIf="data.product.extra.i18n &&
          data.product.extra.i18n[currentLang] &&
          data.product.extra.i18n[currentLang].name;
          else defaultName">
              {{ data.product.extra.i18n[currentLang].name }}
            </span>
            <ng-template #defaultName>{{ data.product.name}}</ng-template>
          </div>
          <div class="product-text pb-1">
            <div class="row">
              <div class="col-12">
                <div class="text-truncate" *ngIf="data.product.productType !== 'concept'">
                  <span
                    *ngIf="data.product.extra.i18n && data.product.extra.i18n[currentLang] &&
                    ( data.product.extra.i18n[currentLang].name || data.product.extra.i18n[currentLang].itemName );
                    else productDefaultName"
                  >
                    {{ data.product.extra.i18n[currentLang].name || data.product.extra.i18n[currentLang].itemName}}
                  </span>
                  <ng-template #productDefaultName  >{{ data.product.name}}</ng-template>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12 col-lg-6" *ngIf="data.product.productType !== 'concept'">
                {{ data.product.id }}
              </div>
              <div class="col-12 col-lg-6" *ngIf="data.product.productType !== 'concept'">
                <lib-availability [availability]="data.availability" [product]="data.product" [isSales]="isSales" *ngIf="includeAvailability">
                </lib-availability>
              </div>
            </div>
            <!--<div class="text-truncate" *ngIf="data.product.productType !== 'concept'">
              <span
                *ngIf="data.product.extra.i18n && data.product.extra.i18n[currentLang] &&
                ( data.product.extra.i18n[currentLang].name || data.product.extra.i18n[currentLang].itemName );
                else productDefaultName"
              >
                {{ data.product.extra.i18n[currentLang].name || data.product.extra.i18n[currentLang].itemName}}
              </span>
              <ng-template #productDefaultName  >{{ data.product.name}}</ng-template>
            </div>-->
            <!-- <div translate *ngIf="data.price" class="font-weight-bold">
              {{ data.price.customerNetPrice.value | gungCurrency: data.price.customerNetPrice.currencyCode }}</div> -->
            <div class="row">
              <div class="col-12" *ngIf="data.product.productType !== 'concept' && !showB2CPrices && !hidePrice">
                <span translate>NET</span>:
                <lib-price [price]="data.price" type="NET" [currency]="data.price.customerNetPrice.currencyCode"
                  class="font-weight-bold"></lib-price>&nbsp;
              </div>
              <div class="col-12 small" *ngIf="data.product.productType !== 'concept' && !showB2CPrices && !hidePrice">
                <span translate>GROSS</span>:
                <lib-price [price]="data.price.backendPriceLevel.extra.ApproximatePrice"
                  [currency]="data.price.customerGrossPrice.currencyCode" class="font-weight-bold"></lib-price>&nbsp;
              </div>
              <div class="col-12 small" *ngIf="data.product.productType !== 'concept' && !!showB2CPrices && !hidePrice">
                <span translate>PRICE</span>:
                <lib-price [price]="data.price?.extra?.b2cPrice"
                  [currency]="data.price.customerGrossPrice.currencyCode" class="font-weight-bold"></lib-price>&nbsp;
              </div>
            </div>
            <div class="product-card-button">
              <div class="input-group" *ngIf="data.product.productType === 'concept'; else buyButton">
                <a [routerLink]="['/product/', data.product.id]" class="text-dark w-100 border-0">
                  <button class="btn btn-block btn-sm btn-primary" tabindex="-1" translate>CONCEPT_SHOW_DETAILS</button>
                </a>
              </div>
              <ng-template #buyButton>
                <lib-buy-btn [id]="data.product.id" [minimumOrderQuantity]="data.product.packageSize"
                  [stepAmount]="data.product.packageSize" [product]="data.product" [availability]="data.availability"></lib-buy-btn>
              </ng-template>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <div *ngIf="findError" class="col-12 mb-2 text-center">
    {{ errorMessage }}
  </div>
</div>
